export interface TidAuthParams {
  redirectUri: string;
  responseType: string;
  clientId: string;
  state: string;
}

export interface TidToken {
  token: string;
}

export interface TidUiParams {
  container: string;
  size: string;
  color: string;
  text: string;
  target: string;
}

export enum TidGenderType {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export interface TidClient {
  email: string;
  phone: string;
  lastName: string;
  firstName: string;
  middleName: string;
  gender: TidGenderType;
}

export interface TidPassport {
  birthdate: string;
  birthPlace: string;
  serial: string;
  number: string;
  issueCode: string;
  issueName: string;
  issueDate: string;
}

export enum TidAddressType {
  REGISTRATION_ADDRESS = 'REGISTRATION_ADDRESS',
  RESIDENCE_ADDRESS = 'RESIDENCE_ADDRESS',
}

export interface TidAddress {
  region: string;
  city: string;
  street: string;
  house: string;
  housing: string;
  building: string;
  apartment: string;
  fiasCode: string;
  zipCode: string;
  type: TidAddressType;
}

export interface TidRegistrationData {
  client?: TidClient;
  passport?: TidPassport;
  addresses?: TidAddress[];
}

export enum TidRegistrationStep {
  CLIENT = 'client',
  PASSPORT = 'passport',
  ADDRESS = 'addresses',
}

export const TID_REDIRECT_URL = {
  SMSFINANCE: {
    DEV: 'https://www.smsfinance.stage-05.fin/registration/auth/tid',
    PROD: 'https://www.smsfinance.ru/registration/auth/tid',
  },
  VIVUS: {
    DEV: 'https://www.vivus.stage-05.fin/register/auth/tid',
    PROD: 'https://www.vivus.ru/register/auth/tid',
  },
};
